import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import PedidoDetalhesViewModel from "@/shared/view-models/PedidoDetalhesViewModel";
import GerarNovoPedidoCaracteristicasViewModel from "@/shared/view-models/GerarNovoPedidoCaracteristicasViewModel";
import Tools from "@/shared/services/tools";
import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";
import novaEmbalagemViewModel from "@/shared/view-models/Filtros/NovaEmbalagemViewModel";

const name = 'DetalhesPedidosCanceladosLiquidados'

export default {
  name,

  components:{
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    PedidoEmAndamentoPDF
  },

  props: { },

  mounted() {
    this.getDetalhesDoPedido()
    this.getDetalhesGeraisDoPedido()
    this.getCaracteristicasDoGerarNovoPedido()
    this.getLogPedidoCanceladoLiquidado()
    // this.getEmbalagemColetiva()
   },

  updated() { },

  data() {
    return {
      detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
      novoPedidoDetalhes : new PedidoDetalhesViewModel(),
      novaEmbalagem : new novaEmbalagemViewModel(),
      caracteristicasPedido : new GerarNovoPedidoCaracteristicasViewModel(),
      embalagensArray:[],
      OrcamentoId: null,
      fsc: null,
      ComponentePedidoArray:[],
      ObsArray: [],
      executarvisualizacao: 0,
      linhaSelecionada: {},
      pdfdownload: false,
      pdfvisualizacao: false,
      PedidoId: null,
      renderiza: false,
    }
  },

  methods: {
    formataDecimal(valor){
      return Tools.valorDecimalFormatado(valor)
    },

    formataMonetario(valor){ 
      return Tools.valorMonetario4Digitos(valor)
    },

    voltar() {
      switch(this.detalhesDoPedidoFluxo.Status){
        case 11:
          this.$router.push(`/pedido-cancelado-liquidado`);
        break
        case 4:
          this.$router.push(`/andamento-de-pedidos`);
        break
        case 5 || 6:
          this.$router.push(`/pedido-cancelado-liquidado`);
        break
        case 13:
          this.$router.push(`/pedido-expedido-faturado`);
        break
      }
    },

    imprimir()
    {
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      this.executarvisualizacao++
    },

    gerarPdf() {
      this.executarvisualizacao++
    },

    getDetalhesDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
          this.OrcamentoIdCerto = this.detalhesDoPedidoFluxo.OrcamentoId;


        })
        .catch(() => {
        });
    },

    getLogPedidoCanceladoLiquidado() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Pedido/GetLogPedidoCanceladoLiquidado/`,
      }).then(() => {

      })
    },


    getDetalhesGeraisDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesGeraisDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.novoPedidoDetalhes, Tools.captalizeKeys(response.data.data))

          this.OrcamentoIdCerto = this.novoPedidoDetalhes.OrcamentoId;

          this.novoPedidoDetalhes.ImpressaoDescricao !== null ? this.ObsArray.push(this.novoPedidoDetalhes.ImpressaoDescricao) : ''
          this.novoPedidoDetalhes.DescricaoVisual !== null ? this.ObsArray.push(this.novoPedidoDetalhes.DescricaoVisual) :''
          this.novoPedidoDetalhes.FacaMedidaDescricao !== null ? this.ObsArray.push(this.novoPedidoDetalhes.FacaMedidaDescricao) : ''
          this.novoPedidoDetalhes.FacaSistemaDescricao !== null ? this.ObsArray.push(this.novoPedidoDetalhes.FacaSistemaDescricao) :''
          this.InformacoesOrcamentoComponenteByOrcamentoId();
        })
        .catch(() => {
        });
    },

    getEmbalagemColetiva() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Componente/GetComponentesByOrcamentoId/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.novaEmbalagem, Tools.captalizeKeys(response.data.data))
          // this.OrcamentoId = this.novaEmbalagem.OrcamentoId;

          // this.novaEmbalagem.ImpressaoDescricao !== null ? this.ObsArray.push(this.novaEmbalagem.ImpressaoDescricao) : ''
          // this.novaEmbalagem.DescricaoVisual !== null ? this.ObsArray.push(this.novaEmbalagem.DescricaoVisual) :''
          // this.novaEmbalagem.FacaMedidaDescricao !== null ? this.ObsArray.push(this.novaEmbalagem.FacaMedidaDescricao) : ''
          // this.novaEmbalagem.FacaSistemaDescricao !== null ? this.ObsArray.push(this.novaEmbalagem.FacaSistemaDescricao) :''
        })
    },

    


    getCaracteristicasDoGerarNovoPedido() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetCaracPedidoFluxo/${this.$route.params.id}`,
        data: {
          PedidoId: this.$route.params.id
        }
      })
        .then((response) => {
          Tools.objectCustomAssign(this.caracteristicasPedido, Tools.captalizeKeys(response.data.data))
        }).finally(() => this.$isLoading(false))
    },


    InformacoesOrcamentoComponenteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Componente/GetComponentesByOrcamentoId/${this.OrcamentoIdCerto}`,
      })
      .then((response) => {
        this.ComponentePedidoArray = response.data.data
        this.novaEmbalagem = response.data.data
        this.ComponentePedidoArray.forEach((r)=>{

          r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x  ${r.numeroAltura} x ${r.numeroAlturaTampa}`
          return this.ColunaMedidas = r.ColunaMedidas
        })
        this.embalagensEspecificas()
      })
      .catch(() => {
      });
    },

    embalagensEspecificas(){
      this.ComponentePedidoArray.forEach((r)=>{
        r.embalagens = []
        r.embalagemFilmeEncolhivel == true ? r.embalagens.push('Filme encolhível - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
        r.embalagemCaixaColetiva == true  ? r.embalagens.push('Caixa Coletiva - ' + `${r.quantidadeCaixaColetiva}`) : ''
        r.embalagemPalete == true  ? r.embalagens.push('Palete - ' + `${r.quantidadePalete}`) : ''
        r.embalagemPapelEmbrulho == true  ? r.embalagens.push('Papel Embrulho - ' + `${r.quantidadePapelEmbrulho}`) : ''
        r.quantidadeOutros == null || 0  ? '' : r.embalagens.push(r.descricaoEmbalagemOutros == null || '' ? 'Outros -' : r.descricaoEmbalagemOutros + `${r.quantidadeOutros}`) 

  })
  },
  },

  computed: { }
};